export default "__VITE_ASSET__590ed827__"